<template>
  <div>
    <div class="d-flex" id="wrapper" :class="{ toggled: isSidebar }">
      <app-sidebar></app-sidebar>
      <div id="page-content-wrapper" style="width:100%" page-content-wrapper>
        <i class="material-icons" id="menu-toggle" @click="isSidebar =  !isSidebar">view_headline</i>
        <app-navbar></app-navbar>
        <div class="container-fluid">
          <div class="col-sm-12">
            <vs-breadcrumb
              align="left"
              :items="
                [
                  {title: 'You are here : '},
                  {
                    title: 'Dashboard',
                    url: '/#/dashboard/program-officer/todoList'
                  },
                  {
                    title: this.updateTraining.title,
                    url: '/#/dashboard/program-officer/todoList'
                  },
                  {
                    title: 'Agenda Form',
                    active: true
                  }
                ]
                  "
            ></vs-breadcrumb>
            <div class="form-group form-row text-dark">
              <h6 class="sub-frm-title">Training Information</h6>
              <div class="row col-sm-12">
                <label class="col-sm-1 font-weight-bold">Title:</label>
                <div class="col-sm-11">{{updateTraining.title}}</div>
              </div>
            </div>
            <template v-if="foundAgenda =='' && editForm == false">
              <form @submit.prevent="addAgenda" style="height:100vh">
                <div class="col-sm-12 p-0">
                  <div class="alert alert-success" v-if="success">{{ success }}</div>

                  <div class="alert alert-danger" v-for="error in errors" :key="error">
                    <b>Please correct the following error(s):</b>
                    {{ error }}
                  </div>
                  <div class="heading mt-3">
                    <h3 class="text-secondary">AGENDA FORM</h3>
                  </div>
                  <!-- block 1 ends -->
                  <!-- block 2 starts -->
                  <div class="form-group form-row text-dark">
                    <h6 class="sub-frm-title">Training Agenda</h6>
                    <div class="row col-sm-12">
                      <selectize
                        class="selectExample"
                        label="No of Days"
                        v-model="dynamicTabs"
                        style="width:100%"
                      >
                        <option
                          style="width:100%"
                          :key="index"
                          :value="item.value"
                          :text="item.text"
                          v-for="(item,index) in tabOptions"
                        >{{item.text}}</option>
                      </selectize>
                      <!-- <template v-if="dynamicTabs !== 0"> -->
                      <!-- bootstrap tabs -->
                      <b-tabs content-class="mt-3 col-xl-12">
                        <b-tab
                          v-for="(item,index) in agendaArr"
                          :key="index"
                          :title="'Day '+item.day"
                          active
                        >
                          <!-- <div class="table-responsive"> -->
                          <div class="col-sm-12 p-0">
                            <table class="table">
                              <thead>
                                <tr>
                                  <th scope="col" style="color: #07a7e19c !important;">
                                    Session No
                                    <span style="color:rgba(255, 0, 0, 0.78);">*</span>
                                  </th>
                                  <th scope="col" style="color: #07a7e19c !important;">
                                    From (Time)
                                    <span style="color:rgba(255, 0, 0, 0.78);">*</span>
                                  </th>
                                  <th scope="col" style="color: #07a7e19c !important;">
                                    To (Time)
                                    <span style="color:rgba(255, 0, 0, 0.78);">*</span>
                                  </th>
                                  <th scope="col" style="color: #07a7e19c !important;">
                                    Title
                                    <span style="color:rgba(255, 0, 0, 0.78);">*</span>
                                  </th>
                                  <th scope="col" style="color: #07a7e19c !important;">
                                    Session By (Trainer)
                                    
                                  </th>
                                  <th scope="col"></th>
                                </tr>
                              </thead>
                              <tbody>
                                <!-- <template> -->
                                  <tr v-for="(item,i) in item.data" :key="i">
                                    <td style="width: 150px;">
                                      <div>
                                        
                                        <input
                                          style="box-shadow: none !important;calc(1.3em + 0.75rem + 2px)"
                                          type="number"
                                          class="form-control"
                                          v-model="item.session"
                                          id="inputtext"
                                          placeholder
                                        />
                                      </div>
                                    </td>
                                    <td>
                                      <div>
                                        <flat-pickr
                                          class="form-control"
                                          style="background: #fff"
                                          placeholder
                                          v-model="item.fromTime"
                                          :config="timeOptions"
                                        ></flat-pickr>
                                      </div>
                                    </td>
                                    <td>
                                      <div>
                                        <flat-pickr
                                          class="form-control"
                                          style="background: #fff"
                                          placeholder
                                          v-model="item.toTime"
                                          :config="timeOptions"
                                        ></flat-pickr>
                                      </div>
                                    </td>
                                    <td>
                                      <div>
                                        <input
                                          style="box-shadow: none !important;calc(1.3em + 0.75rem + 2px)"
                                          type="text"
                                          class="form-control"
                                          id="inputtext"
                                          v-model="item.title"
                                          placeholder
                                        />
                                      </div>
                                    </td>
                                    <td style="width: 200px;">
                                      <selectize
                                        id="select-state"
                                        v-model="item.sessionBy"
                                        :settings="provinceSetting"
                                        :searchable="true"
                                      >
                                        <option
                                          v-for="(itemnew,index) in valuesArray"
                                          :key="index"
                                          :value="itemnew.trainer.trainer_id_user"
                                          :text="itemnew.trainer.trainer_user_id.name"
                                        >{{itemnew.trainer.trainer_user_id.name}}</option>
                                      </selectize>
                                    </td>
                                    <td style="vertical-align: middle;">
                                      <div>
                                        <template v-if="i === 0">
                                          <span @click="addRows(index)">
                                            <vs-icon icon="add_box" class="add-btn"></vs-icon>
                                          </span>
                                        </template>
                                        <template v-else>
                                          <span @click="removeRow(index)">
                                            <vs-icon icon="delete_forever" class="delete-btn"></vs-icon>
                                          </span>
                                        </template>
                                      </div>
                                    </td>
                                  </tr>
                                <!-- </template> -->
                              </tbody>
                            </table>
                          </div>
                          <!-- </div> -->
                        </b-tab>
                      </b-tabs>
                      <!-- </template> -->
                    </div>
                  </div>
                  <!-- block 2 ends -->
                  <!-- save button starts-->
                  <b-button type="submit" class="save-btn" variant="primary" style="margin-top:150px !important">Save</b-button>
                  <!-- save button ends -->
                </div>
              </form>
            </template>
            <template v-else-if="foundAgenda != '' && editForm == false">
              <div class="col-sm-12 p-0 mt-3">
                <h6 class="sub-frm-title">Agenda has been created for this training</h6>
                <b-card class="mt-3">
                  <div class="form-group">
                    <div class="row">
                      <div class="col-sm-12 p-0">
                        <!-- <div class="table-responsive"> -->
                        <div class="mb-1" style="float:right">
                          <b-button
                            variant="outline-primary"
                            @click="EditAgenda(updateTraining.id)"
                            class="mr-1"
                            size="sm"
                          >Edit</b-button>
                          <b-button
                            variant="outline-danger"
                            class="mr-1"
                            size="sm"
                            @click="DeleteAgenda(updateTraining.id)"
                          >Delete</b-button>
                        </div>
                        <div class="table-responsive">
                        <table  class="table" id="display" style="width:100%">
                          <tr>
                            
                            <th>Day</th>
                            <th>Session #</th>
                            <th>Title</th>
                            <th>Assigned To</th>
                            <th>Training Title</th>
                            <th>Created At</th>
                          </tr>
                          <tbody>
                            <tr v-for="(agenda,agendaIndex) in foundAgenda" :key="agendaIndex">
                              
                              <td>{{agenda.days}}</td>
                              <td class="text-capitalize">{{agenda.session}}</td>
                              <td class="text-capitalize">{{agenda.title}}</td>
                              <td class="text-capitalize" v-if="agenda.user != null">{{agenda.user.name}}</td>
                              <td v-else>N/A</td>
                              <td class="text-capitalize">{{agenda.training.title}}</td>

                              <td>{{agenda.createdAt | formatDate}}</td>
                            </tr>
                          </tbody>
                        </table>
                        </div>
                        <!-- </div> -->
                      </div>
                    </div>
                  </div>
                </b-card>

                <!-- new form popup ends -->
              </div>
            </template>
            <template v-if="editForm == true">
              <form @submit.prevent="updateagenda" style="height:100vh">
                <div class="col-sm-12 p-0">
                  <div class="heading mt-3">
                    <h3 class="text-secondary">AGENDA FORM</h3>
                  </div>
                  <!-- block 1 ends -->
                  <!-- block 2 starts -->
                  <div class="form-group form-row text-dark">
                    <h6 class="sub-frm-title">Training Agenda</h6>
                    <div class="row col-sm-12">
                      <selectize
                        class="selectExample"
                        label="No of Days"
                        v-model="updateDynamictabs"
                        style="width:100%"
                      >
                        <option
                          style="width:100%"
                          :key="index"
                          :value="item.value"
                          :text="item.text"
                          v-for="(item,index) in tabOptions"
                        >{{item.text}}</option>
                      </selectize>
                      <b-tabs content-class="mt-3 col-xl-12">
                        <b-tab
                          v-for="(item,index) in agendaArr"
                          :key="index"
                          :title="'Day '+item.day"
                          active
                        >
                          <div class="col-sm-12">
                            <!-- <div class="table-responsive"> -->
                            <table class="table">
                              <thead>
                                <tr>
                                  <th scope="col" style="color: #07a7e19c !important;">Session No</th>
                                  <th scope="col" style="color: #07a7e19c !important;">From (Time)</th>
                                  <th scope="col" style="color: #07a7e19c !important;">To (Time)</th>
                                  <th scope="col" style="color: #07a7e19c !important;">Title</th>
                                  <th scope="col" style="color: #07a7e19c !important;">Session By (Trainer)</th>
                                  <th scope="col"></th>
                                </tr>
                              </thead>
                              <tbody>
                                <template>
                                  <tr v-for="(item,i) in item.data" :key="i">
                                    <td style="width: 150px;">
                                      <div>
                                      
                                        <input
                                          style="box-shadow: none !important;calc(1.3em + 0.75rem + 2px)"
                                          type="number"
                                          class="form-control"
                                          v-model="item.session"
                                          id="inputtext"
                                          placeholder
                                        />
                                      </div>
                                    </td>
                                    <td>
                                      <div>
                                        <flat-pickr
                                          class="form-control"
                                          style="background: #fff"
                                          placeholder
                                          v-model="item.fromTime"
                                          :config="timeOptions"
                                        ></flat-pickr>
                                      </div>
                                    </td>
                                    <td>
                                      <div>
                                        <flat-pickr
                                          class="form-control"
                                          style="background: #fff"
                                          placeholder
                                          v-model="item.toTime"
                                          :config="timeOptions"
                                        ></flat-pickr>
                                      </div>
                                    </td>
                                    <td>
                                      <div>
                                        <input
                                          style="box-shadow: none !important;calc(1.3em + 0.75rem + 2px)"
                                          type="text"
                                          class="form-control"
                                          id="inputtext"
                                          v-model="item.title"
                                          placeholder
                                        />
                                      </div>
                                    </td>
                                    <td style="width:200px">
                                      <selectize
                                        id="select-state"
                                        v-model="item.sessionBy"
                                        :settings="provinceSetting"
                                        :searchable="true"
                                      >
                                        <option
                                          v-for="(itemnew,index) in valuesArray"
                                          :key="index"
                                          :value="itemnew.trainer.trainer_id_user"
                                          :text="itemnew.trainer.trainer_user_id.name"
                                        >{{itemnew.trainer.trainer_user_id.name}}</option>
                                      </selectize>
                                    </td>
                                    <td style="vertical-align: middle;margin-top:0px">
                                      <div>
                                        <template v-if="i === 0">
                                          <span @click="addRows(index)">
                                            <vs-icon icon="add_box" class="add-btn"></vs-icon>
                                          </span>
                                        </template>
                                        <template v-else>
                                          <span @click="removeRow(index)">
                                            <vs-icon icon="delete_forever" class="delete-btn"></vs-icon>
                                          </span>
                                        </template>
                                      </div>
                                    </td>
                                  </tr>
                                </template>
                              </tbody>
                            </table>
                            <!-- </div> -->
                          </div>
                        </b-tab> 
                        
                        <b-button pill @click="closeEditForm" variant="outline-info" style="margin-top:150px">Cancel</b-button>
                        <b-button type="submit" class="save-btn" variant="primary" style="margin-top:150px !important">Update</b-button>
                      </b-tabs>
                    </div>
                  </div>
                </div>
              </form>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Navbar from "./Navbar";
import Sidebar from "./subSidebar";
import axios from "axios";
import selectize from "vue2-selectize";
import "bootstrap/dist/css/bootstrap.css";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";

// Import date picker css
import "pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css";
export default {
  data: () => ({
    success: "",
    training_id:"",
    errors: [],
    foundAgenda: [],
    updateAgenda: [],
    editForm: false,
    isempty: true,
    updateTraining: [],
    isSidebar: false,
    valuesArray: [],
    timeOptions: {
      enableTime: true,
      noCalendar: true,
      dateFormat: "H:i"
    },
    dynamicTabs: 1,
    updateDynamictabs: "",
    tabOptions: [
      // {text:"Select no of Days",value:0},
      { text: 1, value: 1 },
      { text: 2, value: 2 },
      { text: 3, value: 3 },
      { text: 4, value: 4 },
      { text: 5, value: 5 },
      { text: 6, value: 6 },
      { text: 7, value: 7 }
    ],
    checkBox1: true,
    checkBox2: false,
    checkBox3: false,
    days: 0,
    tableArr: 1,
    activeItem: 0,
    search: "",
    trainingId: "",
    trainingCode: "",
    noOfDays: "",
    trainerID: [],
    newArray: [],
    addArray: [],
    select2: 2,
    agendaArr: [
      {
        day: "1",
        data: [
          { session: "", fromTime: "", toTime: "", title: "", sessionBy: "" }
        ]
      }
    ],
    provinceSetting: {
      maxItems: 1,
      searchField: ["text"],
      placeholder: "Select Trainer"
    },
    rowArr: [
      { session: "", fromTime: "", toTime: "", title: "", sessionBy: "" }
    ],
    options1: [
      { text: "1 Day", value: 1 },
      { text: "2 Days", value: 1 },
      { text: "3 Days", value: 2 },
      { text: "4 Days", value: 3 },
      { text: "5 Days", value: 4 }
    ],
    trainerArr: [
      { text: "Dr. Umar Abdur Rahman", value: 1 },
      {
        text: "Dr. Muhammad Abdur Rahman",
        value: 2
      },
      {
        text: "Brig Khalid Mahmood",
        value: 3
      }
    ]
  }),
  mounted() {
    this.trainingCode = this.$route.query.trainingId;
    this.openLoading();
    axios
      .get(
        localStorage.getItem("BASE_PATH") +
          "/programOfficer/trainingsingle/get/" +
          this.trainingCode,{
              headers:{
                Authorization:localStorage.getItem("token"),
              }
            }
        )
        .then(response => {
         
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
              this.closeLoading();
              this.trainingId = response.data.training.id;
              this.updateTraining = response.data.training;
              this.dynamicTabs = this.updateTraining.noofdays;
              this.training_id = this.updateTraining.id
              console.log(this.training_id)
              //check the agenda s already created for this training
              this.allAgendas();
              this.getAllTrainers();
      });
  },
  components: {
    "app-navbar": Navbar,
    "app-sidebar": Sidebar,
    selectize,
    flatPickr
  },
  watch: {
    days(val) {
      this.tableArr = val + 1;
    },
    dynamicTabs(val) {
      this.agendaArr = [];
      for (var i = 0; i < val; i++) {
        this.agendaArr.push({
          day: i + 1,
          data: [
            { session: "", fromTime: "", toTime: "", title: "", sessionBy: "" }
          ]
        });
      }
    },
    updateDynamictabs(val) {
      if (val < this.noOfDays) {
        this.updateDynamictabs = this.noOfDays;
      } else {
        this.agendaArr = [];
        this.newArray.forEach(element => {
          this.agendaArr.push({
            day: element.days,
            data: [
              {
                session: element.session,
                fromTime: element.fromtime,
                toTime: element.totime,
                title: element.title,
                sessionBy: element.user_id
              }
            ]
          });
        });
        for (var i = 0 + this.noOfDays; i < val; i++) {
          this.agendaArr.push({
            day: this.agendaArr.length + 1,
            data: [
              {
                session: "",
                fromTime: "",
                toTime: "",
                title: "",
                sessionBy: ""
              }
            ]
          });
        }
      }
    }
  },
  methods: {
    closeEditForm() {
      this.editForm = false;
      this.updateAgenda = [];
      this.agendaArr = [];
    },
    // this will show all trainers for the current training
    getAllTrainers: function getAllTrainers(){
          this.openLoading();
    axios
      .get(localStorage.getItem("BASE_PATH") + "/trainers/all/"+this.trainingId+"/get",{
              headers:{
                Authorization:localStorage.getItem("token"),
              }
            }
        ,{
              headers:{
                Authorization:localStorage.getItem("token"),
              }
            }
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
        this.closeLoading();
        this.valuesArray = response.data;
      });
    },
    allAgendas: function allAgendas() {
      this.openLoading();
      axios
        .get(
          localStorage.getItem("BASE_PATH") +
            "/check/traninig/agenda/" +
            this.trainingId,{
              headers:{
                Authorization:localStorage.getItem("token"),
              }
            }
        ,{
              headers:{
                Authorization:localStorage.getItem("token"),
              }
            }
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
          this.closeLoading();
          if (response.data.foundagenda != null) {
            this.foundAgenda = response.data.foundagenda;
          } else {
            this.foundagenda = "";
          }
        });
    },
    DeleteAgenda(id) {
      let self = this;
      this.openLoading();
      axios
        .post(localStorage.getItem("BASE_PATH") + "/training/agenda/delete", {
          id: id
        },{
              headers:{
                Authorization:localStorage.getItem("token"),
              }
            }
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
          this.closeLoading();
          if (response.data.success) {
            this.foundAgenda = "";
            self.$toasted.global.successMsg("Agenda has been deleted successfully!");
          } else if (response.data.error) {
            throw response.data.error;
          }
        })
        .catch(error => {
          self.$toasted.global.errorMsg(error);
        });
    },
    EditAgenda(id) {
      this.openLoading();
      axios
        .post(localStorage.getItem("BASE_PATH") + "/training/agenda/edit", {
          id: id
        },{
              headers:{
                Authorization:localStorage.getItem("token"),
              }
            }
        ,{
              headers:{
                Authorization:localStorage.getItem("token"),
              }
            }
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
          this.closeLoading();
          if (response.data) {
            response.data.forEach(element => {
              if(element){
                this.updateDynamictabs = response.data.length;
                this.noOfDays = response.data.length;
                this.newArray = response.data;
              }
            });
          }
          this.editForm = true;
          this.updateAgenda = response.data;
        })
        .catch(error => {
          self.$toasted.global.errorMsg(error);
        });
    },
    toastSuccess(msg) {
      this.$bvToast.toast(msg, {
        title: "Success",
        autoHideDelay: 10000,
        variant: "success",
        solid: true
      });
    },
    toastError(msg) {
      this.$bvToast.toast(msg, {
        title: "Error",
        autoHideDelay: 10000,
        variant: "danger",
        solid: true
      });
    },
    openLoading() {
      this.$vs.loading({
        type: "material"
      });
    },
    closeLoading() {
      this.$vs.loading.close();
    },
    addAgenda(e) {
      e.preventDefault();
      alert(this.training_id)
      this.errors = [];
      // if(!this.session){
      //     this.errors.push("Name is required.");
      // }if(!this.fromTime){
      //     this.errors.push("Name is required.");
      // }if(!this.toTime){
      //     this.errors.push("Name is required.");
      // }if(!this.title){
      //     this.errors.push("Name is required.");
      // }if(!this.sessionBy){
      //     this.errors.push("Name is required.");
      // }
      // if (!this.errors.length) {

      // define -this- outside axios methods because -this- inside axios refers to the axios object, not the vue component:
      let self = this;
      this.isempty = true;
      if (this.agendaArr != undefined && this.agendaArr != null) {
        this.agendaArr.map((element, index) => {
          element.data.map(val => {
            /* if (val.sessionBy == "") {
              this.$toasted.global.errorMsg(
                " Day " + (index + 1) + " Session By  is required."
              );
              this.isempty = false;
            } */
            if (val.session == "") {
              this.$toasted.global.errorMsg("Day " + (index + 1) + " Session  is required.");
              this.isempty = false;
            }
            if (val.title == "") {
              this.$toasted.global.errorMsg("Day " + (index + 1) + " Title is required.");
              this.isempty = false;
            }
          });
        });
      }
      if (this.isempty) {
        this.openLoading();
        axios
          .post(localStorage.getItem("BASE_PATH") + "/register/addAgenda", {
            user_id: JSON.parse(localStorage.getItem("currentUser")).id,

            session: JSON.stringify(this.agendaArr),
            trainingId: this.trainingId,
            training_id:this.training_id
          }
        ,{
              headers:{
                Authorization:localStorage.getItem("token"),
              }
            }
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
            this.closeLoading();
            if (response.data.success) {
              self.$toasted.global.successMsg("Agenda has been added successfully!");
              self.foundAgenda = response.data;
              self.resetForm();
              this.$router.push({
                name: "knowledge-base",
                query: { trainingId: this.trainingCode }
              });
            } else if (response.data.error) {
              throw response.data.error;
            }
          })
          .catch(error => {
            self.success = "";
            self.error = error;
          });
      } else {
        this.closeLoading();
      }

      // }
    },
    updateagenda(e) {
      e.preventDefault();
      this.errors = [];
      let self = this;
      this.isempty = true;
      if (this.agendaArr != undefined && this.agendaArr != null) {
        this.agendaArr.map((element, index) => {
          element.data.map(val => {
            /* if (val.sessionBy == "") {
              this.$toasted.global.errorMsg(
                " Day " + (index + 1) + " Session By  is required."
              );
              this.isempty = false;
            } */
            if (val.session == "") {
              this.$toasted.global.errorMsg("Day " + (index + 1) + " Session  is required.");
              this.isempty = false;
            }
            if (val.title == "") {
              this.$toasted.global.errorMsg("Day " + (index + 1) + " Title is required.");
              this.isempty = false;
            }
          });
        });
      }
      if (this.isempty) {
        this.openLoading();
        axios
          .post(localStorage.getItem("BASE_PATH") + "/update/Agenda", {
            user_id: JSON.parse(localStorage.getItem("currentUser")).id,
            session: JSON.stringify(this.agendaArr),
            trainingId: this.trainingId
          },{
              headers:{
                Authorization:localStorage.getItem("token"),
              }
            }
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
            this.closeLoading();
            if (response.data.success) {
              self.$toasted.global.successMsg("Agenda has been updated successfully!");
              self.foundAgenda = response.data;
              self.resetForm();
              this.$router.push({
                name: "knowledge-base",
                query: { trainingId: this.trainingCode }
              });
            } else if (response.data.error) {
              throw response.data.error;
            }
          })
          .catch(error => {
            self.success = "";
            self.error = error;
          });
      } else {
        this.closeLoading();
      }
    },
    resetForm() {},
    addRows(val) {
      this.agendaArr[val].data.push({
        session: "",
        fromTime: "",
        toTime: "",
        title: "",
        sessionBy: ""
      });
    },
    removeRow(val) {
      this.agendaArr[val].data.pop();
    },
    showForm() {
      this.isForm = false;
      this.isFormData = true;
    },
    successUpload() {
      this.$vs.notify({
        color: "success",
        title: "Upload Success",
        text: "Files have been Uploaded, consectetur"
      });
    }
  }
};
</script>
<style scoped>
#menu-toggle {
  display: none;
}

@media (max-width: 768px) {
  #menu-toggle {
    display: block;
  }
}

.f-500 {
  font-weight: 500;
}
.dblock {
  display: block !important;
}
.input-color {
  margin-bottom: 10px;
  position: relative;
  display: block;
}
.myNavbar {
  color: rgb(255, 255, 255);
}
.dflex {
  display: flex;
}
.fcenter {
  justify-content: center;
  align-items: center;
}
.pleft-5 {
  margin-left: 5px;
}
.selectExample {
  margin: 10px;
}
.con-select-example {
  display: flex;
  align-items: center;
  justify-content: center;
}
.con-select .vs-select {
  width: 100%;
}
@media (max-width: 550px) {
  .con-select {
    flex-direction: column;
  }
  .con-select .vs-select {
    width: 100%;
  }
}

.form-row {
  padding: 8px;
  color: #1465a3;
  border: 1px dotted #07a7e14f;
  margin-left: 0px !important;
  margin-right: 0px !important;
}

.field {
  width: 100%;
  text-transform: capitalize;
  border-bottom: 2px solid #d0d0d0;
  border-top: none !important;
  border-left: none !important;
  border-right: none !important;
  box-shadow: none !important;
  border-radius: 0 !important;
  transition: all 0.2s ease-in-out 0.2s;
  -webkit-transition: all 0.2s ease-in-out 0.2s;
  -moz-transition: all 0.2s ease-in-out 0.2s;
}
.sub-frm-title {
  padding: 5px;
  background-color: #fff;
  margin-top: -25px;
  text-align: center;
  color: rgba(7, 167, 225, 0.61);
}
/* overide css of vuesax */
.vs-con-input-label {
  width: 100% !important;
}
.vs-con-input-label.is-label-placeholder {
  margin-top: 8px !important;
}
.frm-title {
  text-align: center;
  padding: 10px;
  color: #009ad2;
  /* border-bottom: 2px solid #009ad2; */
}
.save-btn {
  box-shadow: none;
  border-color: rgba(7, 167, 225, 0.61);
  background-color: rgba(7, 167, 225, 0.61);
  float: right;
  margin: 0px 0px !important;
  height: 36px;
  line-height: 0;
}
.add-btn {
  font-size: 25px !important;
  color: rgba(7, 167, 225, 0.61);
  cursor: pointer;
}
.delete-btn {
  font-size: 25px;
  color: rgba(255, 0, 0, 0.78);
  cursor: pointer;
}
.btn-primary:not(:disabled):not(.disabled):active,
.btn-primary:not(:disabled):not(.disabled).active,
.show > .btn-primary.dropdown-toggle {
  color: #fff;
  border-color: rgba(7, 167, 225, 0.61);
  background-color: rgba(7, 167, 225, 0.61);
}

.new-training {
  padding-right: 10px;
}
.title-text {
  margin-bottom: 0px;
}
.selectize-control.multi .selectize-input > div {
  background: rgba(7, 167, 225, 0.61);
  color: #333333;
}
.con-select {
  font-size: 0.85rem !important;
}
.selectize-input.items.not-full.has-options.has-items {
  font-size: 0.85rem !important;
}

/* Floating label css starts */
/****  floating-Lable style start ****/
.floating-label {
  position: relative;
  margin-bottom: 5px;
}
.floating-input,
.floating-select {
  font-size: 14px;
  padding: 4px 30px 4px 5px;
  display: block;
  width: 100%;
  height: 36px;
  box-shadow: none !important;
  /* background-color: transparent; */
  border: none;
  border: 1px solid #ccc;
}

.floating-input:focus,
.floating-select:focus {
  outline: none;
  border: 2px solid rgba(7, 167, 225, 0.61);
}

label.lbl-label {
  color: #ccc;
  font-size: 14px;
  font-weight: normal;
  position: absolute;
  pointer-events: none;
  left: 5px;
  top: 6px;
  transition: 0.2s ease all;
  -moz-transition: 0.2s ease all;
  -webkit-transition: 0.2s ease all;
}

.floating-input:focus ~ label.lbl-label,
.floating-input:not(:placeholder-shown) ~ label.lbl-label {
  background-color: #f9f9f9;
  /* background-color: #fff; */
  top: -12px;
  left: 10px;
  font-size: 14px;
  color: rgba(7, 167, 225, 0.61);
  padding: 0px 5px;
}

.floating-select:focus ~ llabel.lbl-label,
.floating-select:not([value=""]):valid ~ label.lbl-label {
  top: -18px;
  font-size: 14px;
  color: #5264ae;
}

/* active state */
.floating-input:focus ~ .bar:before,
.floating-input:focus ~ .bar:after,
.floating-select:focus ~ .bar:before,
.floating-select:focus ~ .bar:after {
  width: 50%;
}

*,
*:before,
*:after {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}

/* highlighter */
/* .highlight {
  position: absolute;
  height: 50%;
  width: 100%;
  top: 15%;
  left: 0;
  pointer-events: none;
  opacity: 0.5;
} */



/****  floating-Lable style end ****/

/* Floating label css ends */
.sub-frm-title {
  background-color: #fff;
}
.vs-popup--background {
  opacity: 0.3 !important;
}
.con-img-upload .img-upload {
  width: 150px !important;
}

.floating-input:focus ~ label.lbl-label,
.floating-input:not(:placeholder-shown) ~ label.lbl-label {
  background-color: #fff;
  /* background-color: #fff; */
  top: -12px;
  left: 10px;
  font-size: 14px;
  color: rgba(7, 167, 225, 0.61);
  padding: 0px 5px;
}
</style>


